import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import GetMailTemplates             from "../../../../../application/usecase/mail/template/GetMailTemplates";
import MailTemplates                from "../../../../../domain/mail/template/MailTemplates";
import { ResKaState }               from "../../../../../index";
import ListPagination               from "../../../common/ListPagination";

const MailTemplatesPagination: FC = () => {
  const mailTemplates: MailTemplates = useSelector((state: ResKaState) => state.mailTemplates);
  const getMailTemplates: GetMailTemplates = new GetMailTemplates(useDispatch());
  return (
    <>
      <ListPagination
        currentPage={ mailTemplates.pagination.current }
        totalPage={ mailTemplates.pagination.total }
        onChangePage={ currentPage => getMailTemplates.execute(currentPage) }
      />
    </>
  );
};

export default MailTemplatesPagination;
